import React from 'react'

const WorkInfo = ({workInfo, handleWorkInfoChange}) => {
  return (
    <div className="member-form-section">
        <div className="bg-primary text-secondary px-5 py-2">
          EDUCATION & WORK INFORMATION
        </div>
        <div className="member-form-body">
          <div>
            {/* FIRST ROW */}
            <div className="grid lg:grid-cols-3 gap-5 p-5">
              {/* HIGHEST EDUCATION QUALIFICATION */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Highest Education Qualification
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="highest_qualification"
                  id="highest_qualification"
                  onChange={(e) => handleWorkInfoChange(e)}
                  value={workInfo?.highest_qualification}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* PROFESSION */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Profession<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="profession"
                  id="profession"
                  onChange={(e) => handleWorkInfoChange(e)}
                  value={workInfo?.profession}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* OCCUPATION */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Occupation<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="occupation"
                  id="occupation"
                  onChange={(e) => handleWorkInfoChange(e)}
                  value={workInfo?.occupation}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* PLACE OF WORK */}
              <div className="flex flex-col">
                <label htmlFor="">
                  Place of work<span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="place_of_work"
                  id="place_of_work"
                  onChange={(e) => handleWorkInfoChange(e)}
                  value={workInfo?.place_of_work}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
              {/* CONTACT NUMBER */}
              <div className="flex flex-col">
                <label htmlFor="">Contact Number</label>
                <input
                  type="text"
                  name="work_contact"
                  id="work_contact"
                  onChange={(e) => handleWorkInfoChange(e)}
                  value={workInfo?.work_contact}
                  className="border border-gray-500 px-3 py-2 outline-none rounded"
                />
              </div>
            </div>
           
          </div>
        </div>
      </div>
  )
}

export default WorkInfo